<div class="urgency-boost-settings" [formGroup]="formGroup">
  <pdq-card variant="popover" color="white">
    <div class="card-content">
      <pdq-heading element="h6">Token for Shopify</pdq-heading>
      <pdq-divider></pdq-divider>
      <pdq-input
        [disabled]="true"
        formControlName="usageToken"
        label="Copy & paste this into Shopify's components by 'Urgency Boost'"
        [clipboard]="true"></pdq-input>
      <pdq-extension-preview-token [usageTokenControl]="formGroup.get('usageToken')"></pdq-extension-preview-token>
    </div>
  </pdq-card>

  <pdq-card variant="popover" color="white">
    <div class="card-content">
      <pdq-heading element="h6">General</pdq-heading>
      <pdq-divider></pdq-divider>

      <pdq-input
        label="Internal name"
        formControlName="internalName"
        [invalid]="formGroup.get('internalName')?.touched && formGroup.get('internalName')?.hasError('required')"
        invalidMsg="Internal name is required"></pdq-input>
      <pdq-input
        label="Internal description"
        formControlName="internalDescription"
        placeholder="Enter description"></pdq-input>

      <div class="max-badges-row">
        <pdq-input-arrows
          formControlName="maxBadgesPerProduct"
          [min]="0"
          [required]="false"
          placeholder="Unlimited"
          label="Maximum boosts per product"
          widthSize="fullwidth"></pdq-input-arrows>
        <span class="hint"
          >Limits how many boosts appear on a product when multiple groups apply.<br />Leave empty for no limit</span
        >
      </div>
    </div>
  </pdq-card>

  <pdq-card variant="popover" color="white">
    <div class="card-content">
      <pdq-heading element="h6">Layout</pdq-heading>
      <pdq-divider></pdq-divider>

      <div class="top-margin-row" formGroupName="layout">
        <pdq-dropdown
          title="Space above badge"
          formControlName="spaceAboveBadge"
          [options]="topMarginOptions"
          [fullWidth]="true"></pdq-dropdown>
      </div>
    </div>
  </pdq-card>
</div>
